export default __webpack_public_path__ + "static/media/Nesrine_Mrabet_Resume_2023.07896172.pdf";